import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09247a73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-container" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "ion-text-uppercase item-key" }
const _hoisted_4 = { class: "item-value" }
const _hoisted_5 = { class: "ion-text-capitalize profile-name" }
const _hoisted_6 = {
  key: 0,
  class: "profile-status-tag profile-active-tag"
}
const _hoisted_7 = {
  key: 1,
  class: "profile-status-tag profile-inactive-tag"
}
const _hoisted_8 = { class: "profile-known-as" }
const _hoisted_9 = { class: "ion-text-wrap profile-bio" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ion-text-uppercase item-key" }, "Favorite Course", -1))
const _hoisted_11 = { class: "ion-text-capitalize item-value" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ion-text-uppercase item-key" }, "Open to gambling", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_item = _resolveComponent("ion-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_row, { class: "profile-top-section" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, {
                  size: "auto",
                  class: "ion-align-items-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_avatar, null, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _ctx.user.picture_url,
                          alt: `${_ctx.user.first_name}${_ctx.user.last_name}`
                        }, null, 8, _hoisted_2)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, { class: "profile-content" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topContent, (value, key, index) => {
                          return (_openBlock(), _createBlock(_component_ion_col, {
                            size: "auto",
                            key: index
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_3, _toDisplayString(key), 1),
                              _createElementVNode("p", _hoisted_4, _toDisplayString(value), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    (_ctx.isAuthUser)
                      ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                          default: _withCtx(() => [
                            (_ctx.openUserProfileModal)
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 0,
                                  class: "profile-action-btn",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openEditModal()))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Edit Profile")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_ion_button, {
                              class: "profile-action-btn",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onLogout()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Sign Out")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_row, { class: "profile-main-section" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", _hoisted_5, [
                          _createTextVNode(_toDisplayString(_ctx.user.first_name + ' ' +  _ctx.user.last_name) + " ", 1),
                          (_ctx.user.is_active)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Active"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_7, "Inactive"))
                        ]),
                        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.user.profile.known_as), 1),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.user.profile.bio), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_row, { class: "profile-bottom-section" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, { class: "profile-content" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, { size: "auto" }, {
                          default: _withCtx(() => [
                            _hoisted_10,
                            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.user.profile.favorite_course), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, { size: "auto" }, {
                          default: _withCtx(() => [
                            _hoisted_12,
                            (_ctx.user.profile.gambling)
                              ? (_openBlock(), _createBlock(_component_ion_icon, {
                                  key: 0,
                                  color: "success",
                                  icon: _ctx.checkmark,
                                  class: "item-icon"
                                }, null, 8, ["icon"]))
                              : (_openBlock(), _createBlock(_component_ion_icon, {
                                  key: 1,
                                  color: "danger",
                                  icon: _ctx.ban,
                                  class: "item-icon"
                                }, null, 8, ["icon"]))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}